import type { SurveyPage, SurveyQuestion } from '../types.js';

export function orderedPages(pages: SurveyPage[]): SurveyPage[] {
  return [...pages].sort((first, second) => (first.order ?? 0) - (second.order ?? 0));
}

export function groupQuestionsByPage(questions: SurveyQuestion[]): Record<string, SurveyQuestion[]> {
  const output: Record<string, SurveyQuestion[]> = {};
  const sorted = [...questions].sort((first, second) => (first.order ?? 0) - (second.order ?? 0));
  for (const question of sorted) {
    if (!output[question.pageKey]) output[question.pageKey] = [];
    output[question.pageKey]!.push(question);
  }
  return output;
}

export function isContentPage(page: SurveyPage): boolean {
  return !page.isThankYou && !page.isWelcome;
}

// Visible content pages are non-welcome/non-thank-you pages that aren't marked
// defaultHidden. Path pages (defaultHidden: true) still render via computeNextPage
// when their entry rules match; we just don't count them for the progress bar.
export function visibleContentPages(pages: SurveyPage[]): SurveyPage[] {
  return pages.filter((page) => isContentPage(page) && !page.logic?.defaultHidden);
}

export function countContentPages(pages: SurveyPage[]): number {
  return visibleContentPages(pages).length;
}

export function findContentPageIndex(pages: SurveyPage[], currentKey: string | undefined): number {
  return visibleContentPages(pages).findIndex((page) => page.key === currentKey);
}

export function findWelcomePageIndex(pages: SurveyPage[]): number {
  return pages.findIndex((page) => page.isWelcome);
}

export function findThankYouPageIndex(pages: SurveyPage[]): number {
  return pages.findIndex((page) => page.isThankYou);
}

export function previousContentPageIndex(pages: SurveyPage[], current: number): number {
  for (let index = current - 1; index >= 0; index -= 1) {
    const page = pages[index];
    if (page && isContentPage(page) && !page.logic?.defaultHidden) return index;
  }
  return current;
}
